import React from "react";
import AdyenCheckout from "@adyen/adyen-web";
import "../../../node_modules/@adyen/adyen-web/dist/adyen.css";
import { StepForm } from "../state-transition/StateTransition";
import moment from "moment";
import { isEmpty } from "lodash";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  resetPersonalInfoData,
  restExamDetails,
  restInstitutionDetails,
  getExamSeriesError,
  getInstitutionsError
} from "./../../redux-building-blocks/actions";
import Modal from "../shared/modal/Modal";
import MulesoftDataService from '../../services/mulesoftData.services';
export class AdyenPaymentForm extends React.Component {
  constructor(props) {
    super(props);    
    this.state = {
      overlay: false,
      amount:0,
      amountInCents:"",
      cardDetails: {},
      errorMsg:"",
      ipAddress:"",
      modalType:""
    };    
  } 

  configureAdyenComponent = async () => {
    const {transcriptRates,updatedCardDetails} = this.props,
          userAmount = transcriptRates.totalTranscriptAmount,
          totalAmountinCents = Number(userAmount) * 100;
    
    // Ensure full cleanup
    if (this.cardComponent?.unmount) {
      this.cardComponent.unmount();
      this.cardComponent = null;
    }
    this.checkout = null;  // force brand-new checkout instance each time
  
    const adyenContainer = document.getElementById("adyenForm");
    if (adyenContainer) adyenContainer.innerHTML = "";

    // Recreate AdyenCheckout fresh – clears old securedFields registry
    this.checkout = await AdyenCheckout({
      clientKey: process.env.REACT_APP_ADYEN_CLIENT_KEY,
      countryCode: transcriptRates.transcriptsCost[0].countryCode,
      environment: process.env.REACT_APP_ADYEN_ENVIRONMENT,
      amount: {
        value: totalAmountinCents,
        currency: transcriptRates.transcriptsCost[0].currency,
      },
      showPayButton: true,
      paymentMethodsConfiguration: {
        card: {
          hasHolderName: true,
          holderNameRequired: true,
          placeholders: {
            holderName: "Enter name on card",
            cardNumber: "XXXX XXXX XXXX XXXX",
            expiryDate: "MM/YY",
            securityCodeThreeDigits: "3 Digits",
            securityCodeFourDigits: "4 Digits",
          },
        },
      },
      onError: (error, component) => {
        console.error(error.name, error.message, error.stack, component);
        const { payLater } = this.showHidePayAndLater();
        if (payLater) payLater.style.display = 'block';
      },
      onSubmit: async(state,component) => {
        const {confirmationInfo} = this.props;
        const transactionID = confirmationInfo.requestId + "-" + new Date().getTime();
        const args = { payload: {
          data: {applicationReferenceNumber: confirmationInfo.requestId, paymentDueDate: confirmationInfo.paymentDueDate, transactionId: transactionID}
        }};
        const response = await MulesoftDataService.validatePaymentDue(args);
      
        if (response?.data?.paymentCompleted === true) {
          this.setState({ overlay: true, modalType: 'duplicatePayment' });
          return;
        }
        this.navToThreeDAuthPageFromCardDetail(state,component)
      },
      onAdditionalDetails: (state, component) => {
				this.finalPayResponse(state.data,{});
      },
      onActionHandled: () => {
        console.log("action handled");
      }      
    });
    this.cardComponent = await this.checkout.create("card").mount("#adyenForm");   
    this.setState({ amount:userAmount,amountInCents:totalAmountinCents,
                    cardDetails:isEmpty(updatedCardDetails)?this.cardComponent:updatedCardDetails.cardDetails });
       
  };
  componentDidMount(){
    this.configureAdyenComponent();    
    this.ipAddressFetch();
  }

  showHidePayAndLater = () =>{
    const payLater = document.getElementById("payLater");
    return {payLater};
  }

  ipAddressFetch = async () =>{
    const res = await MulesoftDataService.fetchIPaddress();
    this.setState({ipAddress:res.data.ip});
  }

  navToThreeDAuthPageFromCardDetail = async (state,component) => {    
      const {transcriptRates,confirmationInfo,userProfile} = this.props,      
            {payLater} = this.showHidePayAndLater();

      payLater.style.display = 'none';

      if(state.isValid){
        const requestObject = {
          amount: {
            currency: transcriptRates.transcriptsCost[0].currency,
            value: this.state.amountInCents,
          },
          countryCode: transcriptRates.transcriptsCost[0].countryCode,
          reference:confirmationInfo.requestId,
          authenticationData: {
						threeDSRequestData: {
							nativeThreeDS: "preferred"
						}
					},
          browserInfo: state.data.browserInfo,
					origin: window.location.origin,
					channel: "Web",
					returnUrl: window.location.origin,
					paymentMethod: state.data.paymentMethod,
          shopperIP: this.state.ipAddress,
          shopperEmail: userProfile?.email,
          returnUrl: "/confirmation"
        },
        response = await MulesoftDataService.submitCardDetails(requestObject);
        if(!isEmpty(response?.data?.action)){
          component.handleAction(response.data.action);
        }else if(!isEmpty(response?.data?.resultCode)){
          this.finalPayResponse({},response);       
        }
      }
  }

  finalPayResponse = async (request,response) =>{
    let resp,status,
    {payLater} = this.showHidePayAndLater();            
      
    if(!isEmpty(request)){
      resp = await MulesoftDataService.finalPayRequestAfterThreeDAuth(request,this.props.confirmationInfo.requestId);
    }else{
      resp = response;
    }
    status = resp?.data?.resultCode?.toLowerCase();
    if (status === "authorised" || status === "authorisedpending" || status === "pending" || status === "received") {
      this.paymentSuccessDetails(resp.data);
      if(payLater){
        payLater.style.display = 'block';
      }
      this.props.history.push("/confirmation");
    }else {
      payLater.style.display = 'block';
      this.configureAdyenComponent();
      this.setState({ overlay: !this.state.overlay, modalType: 'adyen', errorMsg:resp?.data?.refusalReason });
    }			
  }

  paymentSuccessDetails = ({pspReference,resultCode}) => {
    const {confirmationInfo,userProfile,nameFromHistory,examDetailsList,
           institutionDetailsList,transcriptRates,stateNavFlags,
           examSeries,institutionApivalues} = this.props, 
          obj = {
            orderNumber: confirmationInfo.requestId,
            date: moment(new Date()).format('MMMM DD, yyyy'),
            name: !isEmpty(nameFromHistory.fNameFromHistory)?nameFromHistory.fNameFromHistory+" "+nameFromHistory.lNameFromHistory:
                                                userProfile?.given_name+" "+userProfile?.family_name,
            email: userProfile?.email,
            exams: stateNavFlags.isHistoryPayNav?examSeries:examDetailsList,
            institutions: stateNavFlags.isHistoryPayNav?institutionApivalues:institutionDetailsList,
            fee: transcriptRates.totalTranscriptAmount.toFixed(2),
            directToPay: stateNavFlags.isHistoryPayNav,
            payReferenceNumber:pspReference,
            status:resultCode
          };
    localStorage.setItem('transcript', JSON.stringify(obj)); 
  }

  reDirectToHistory = () => {
    if (this.props.stateNavFlags.isHistoryPayNav) {
      this.props.getExamSeriesError();
      this.props.getInstitutionsError();
    }
    this.props.resetPersonalInfoData();
    this.props.restExamDetails();
    this.props.restInstitutionDetails();
    this.props.history.push("/transcript-history");
  };

  hideModal = () => {
    if(this.state.modalType === 'paymentDue') {
      this.reDirectToHistory()
    }
    this.setState({ overlay: !this.state.overlay, modalType: '' });
  };

  render() {
    const {confirmationInfo,location,commonData} = this.props;
    return (
      <React.Fragment>       
        <div className="w-100">
          <StepForm pathname={location.pathname}></StepForm>           
            <div className="mt-4 mb-2">
              <h2 style={{ fontWeight: 700 }} className="mt-4">
                Payment form
              </h2>            
            </div>
            <div className="mt-2 mb-2">
              <span className="sub-label mr-2">Order number:</span>
              <span>{confirmationInfo.requestId + "-" + new Date().getTime()}</span>
            </div>
            <div className="mt-2 mb-2">
              <span className="sub-label mr-2">Application submitted date:</span>
              <span>{moment(confirmationInfo.applicationSubmittedDate).format('DD MMMM yyyy')}</span>
            </div>
          {!isEmpty(confirmationInfo.paymentDueDate) && <div className="mt-2 mb-4">
            <span className="sub-label mr-2">Payment due date:</span>
            <span>{moment(confirmationInfo.paymentDueDate).format('DD MMMM yyyy, HH:mm')}</span>
          </div>}
          <div id="adyenForm"></div>
          <div className="mb-4">
            <button id="payLater" onClick={this.reDirectToHistory} className="btn btn-link text-decoration-none save-button-review w-100 text-white mt-2"style={{fontWeight: 'bold'}}>
              <span>Pay later</span>
            </button>
          </div>
          <div>
            <Modal
              show={this.state.overlay}
              hideModal={this.hideModal}
              rec={this.state.modalType}
              mobile={commonData.mobileDevice}
              handleContinue={this.handleContinue}
              userMsg={this.state.errorMsg}
            />
          </div>
        </div>
      </React.Fragment>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    userProfile: state.currentUser.profile,
    nameFromHistory: state.currentUser,
    institutionDetailsList: state.institutesDetailsInfo.institutesDetailList,
    institutionApivalues: state.institutesDetailsInfo.institutionApivalues,
    transcriptRates: state.reviewConfirm,
    confirmationInfo: state.ConfirmationInfo,
    examDetailsList: state.examDetailsInfo.examDetailsList,
    examSeries: state.examDetailsInfo.examSeriesApiValues,
    stateNavFlags: state.stateTransition,
    terms: state.termsAndConditionsReducer.conditionsApiText,
    commonData: state.commonData,
  };
};
const mapDispachToProps = {
  resetPersonalInfoData,
  restExamDetails,
  restInstitutionDetails,
  getExamSeriesError,
  getInstitutionsError
};
export default withRouter(
  connect(mapStateToProps, mapDispachToProps)(AdyenPaymentForm)
);